import { Typography } from '@/components/atoms';
import { BellIcon } from '@/components/atoms/icons';
import { useUIColors } from '@/core/hooks';
import { useI18nContext } from '@/core/providers/I18nProvider';
import { getShadowStyle } from '@/core/utils/shadowStyles';
import React from 'react';
import { StyleSheet, View } from 'react-native';

export interface NotificationCardProps {
    title: string;
    body: string;
    iconSize?: number;
}

export const NotificationCard: React.FC<NotificationCardProps> = ({
    title,
    body,
    iconSize = 20,
}) => {
    const colors = useUIColors();
    const { isRTL } = useI18nContext();

    return (
        <View style={[styles.container, getShadowStyle(styles.shadow), { backgroundColor: colors.backgroundLevel1 }]}>
            <View style={[styles.titleRow, isRTL && { flexDirection: 'row-reverse' }]}>
                {isRTL ? (
                    <>
                        <Typography
                            variant="subhead"
                            color="primary"
                            numberOfLines={1}
                            style={[styles.title, styles.titleRTL]}
                        >
                            {title}
                        </Typography>
                        <View style={styles.iconWrapper}>
                            <BellIcon size={iconSize} color={colors.vectorsIconGreyscale} />
                        </View>
                    </>
                ) : (
                    <>
                <View style={styles.iconWrapper}>
                    <BellIcon size={iconSize} color={colors.vectorsIconGreyscale} />
                </View>
                <Typography
                    variant="subhead"
                    color="primary"
                    numberOfLines={1}
                            style={styles.title}
                >
                    {title}
                </Typography>
                    </>
                )}
            </View>
            <Typography
                variant="body"
                color="tertiary"
                style={[styles.body, isRTL && styles.bodyRTL]}
            >
                {body}
            </Typography>
        </View>
    );
};

const styles = StyleSheet.create({
    container: {
        borderRadius: 16,
        paddingVertical: 10,
        paddingHorizontal: 16,
        elevation: 2, // Android shadow
    },
    shadow: {
        shadowColor: '#000',
        shadowOpacity: 0.15,
        shadowOffset: { width: 0, height: 2 },
        shadowRadius: 6,
        elevation: 2,
    },
    titleRow: {
        flexDirection: 'row',
        alignItems: 'center',
        gap: 2,
        marginBottom: 4,
    },
    iconWrapper: {
        width: 24,
        height: 24,
        justifyContent: 'center',
        alignItems: 'center',
    },
    title: {
        flex: 1,
        lineHeight: 20,
    },
    body: {
        lineHeight: 20,
        // Aligned with bell icon on the left (no margin)
    },
    titleRTL: {
        textAlign: 'right',
    },
    bodyRTL: {
        textAlign: 'right',
    },
});

export default NotificationCard;

